import React from "react";
import { Flex, Button } from "@chakra-ui/react";

interface FooterButtonProps {
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
}

const FooterButtons = ({
  primaryBtnTxt,
  secondaryBtnTxt,
  onSubmitPrimary,
  onSubmitSecondary,
}: FooterButtonProps) => {
  return (
    <Flex
      flexDirection={{
        base: "column-reverse",
        md: "row",
      }}
      alignItems="center"
      justifyContent="center"
    >
      {secondaryBtnTxt && onSubmitSecondary && (
        <Button
          variant="unstyled"
          p="12px 45px"
          bg="backgroundCard"
          color="textPrimary"
          border="1px"
          borderColor="seperator"
          onClick={onSubmitSecondary}
          mr={{
            base: "0rem",
            md: "1rem",
          }}
          mt={{
            base: "1rem",
            md: "0rem",
          }}
          borderRadius="0.5rem"
          lineHeight="0"
          fontSize="16px"
          // w="fit-content"
          minW={{ base: "256px", md: "fit-content" }}
          h="48px"
        >
          {secondaryBtnTxt}
        </Button>
      )}
      {primaryBtnTxt && onSubmitPrimary && (
        <Button
          variant="unstyled"
          p="12px 45px"
          bg="textPrimary"
          color="white"
          borderRadius="0.5rem"
          onClick={onSubmitPrimary}
          fontSize="16px"
          h="48px"
          minW={{ base: "256px", md: "fit-content" }}
        >
          {primaryBtnTxt}
        </Button>
      )}
    </Flex>
  );
};

export default FooterButtons;
